import { render, staticRenderFns } from "./FormControlUsersRoles.vue?vue&type=template&id=315bf5de"
import script from "./FormControlUsersRoles.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlUsersRoles.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports